/**
 * MiniSearch indexes snapshot Firestore once; without a TTL, posts created
 * after the first search never appear until a full tab reload. Tunable via
 * `REACT_APP_SEARCH_INDEX_TTL_MS` (milliseconds; `0` = refresh every search).
 */
export function getSearchIndexTtlMs() {
  const raw = process.env.REACT_APP_SEARCH_INDEX_TTL_MS;
  const parsed = raw ? parseInt(String(raw), 10) : NaN;
  if (Number.isFinite(parsed) && parsed >= 0) return parsed;
  return 3 * 60 * 1000;
}
